import type { ComponentPropsWithRef } from 'react';

import { useTranslation } from 'react-i18next';

import { clsx } from '~/styles/utils';

import { rootStyle } from './FilterChips.css';

type Props = ComponentPropsWithRef<'ul'>;

export const FilterChipsRoot = ({ children, ...delegated }: Props) => {
  const { t } = useTranslation(['common']);

  return (
    <ul aria-label={t('common:datatable.filters')} {...delegated} className={clsx(rootStyle, delegated.className)}>
      {children}
    </ul>
  );
};
